module.exports = __webpack_public_path__ + "img/Proliferation-CRC_GSE206552.622eece8.png";